export const AI_FEEDBACK_TYPES = {
  HELPFUL: 'helpful',
  NOT_HELPFUL: 'not_helpful',
} as const;

export type AIFeedbackType = (typeof AI_FEEDBACK_TYPES)[keyof typeof AI_FEEDBACK_TYPES];

export const AI_FEEDBACK_FEATURE_TYPES = {
  CATEGORY_SCORING: 'category_scoring',
  ACTION_PLAN: 'action_plan',
  CMI_DIGEST_COMMUNITY: 'cmi_digest_community',
  COMPANY_AI_OVERVIEW: 'company_ai_overview',
  COMMUNITY_AI_OVERVIEW: 'community_ai_overview',
} as const;

export type AIFeedbackFeatureType = (typeof AI_FEEDBACK_FEATURE_TYPES)[keyof typeof AI_FEEDBACK_FEATURE_TYPES];
